import { render, staticRenderFns } from "./ModalEditComment.vue?vue&type=template&id=7111afa1&scoped=true"
import script from "./ModalEditComment.vue?vue&type=script&lang=js"
export * from "./ModalEditComment.vue?vue&type=script&lang=js"
import style0 from "./ModalEditComment.vue?vue&type=style&index=0&id=7111afa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7111afa1",
  null
  
)

export default component.exports